<!--
 * @Author: wsx
 * @Date: 2022-01-14 10:26:06
 * @LastEditTime: 2022-06-15 18:04:11
 * @LastEditors: zhangyaowen zhangyaowen_520@163.com
 * @Description: 成员列表
-->
<template>
  <div class="TabsTable">
    <el-row>
      <el-col :span="5">
        <h-button type="primary" @click="moveMember">移入成员</h-button>
      </el-col>
    </el-row>
    <h-table
      ref="tableRef"
      v-model:columns="columns"
      :method="queryUserList"
      :params="tableParams"
      @handleClick="handleClick"
    >
    </h-table>
    <el-dialog v-model="moveVisible" title="移入成员" width="40%">
      <div class="organTransfer">
        <h-transfer
          v-model="transferKeys"
          nodeKey="treeId"
          checkedKey="userId"
          :props="{ value: 'treeId', label: 'name' }"
          :data="treeOrganPerson"
          :default-expanded-keys="[rootNodeKey]"
          :titles="['成员', '已选']"
          :buttonTexts="['添加', '移出']"
        ></h-transfer>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <h-button type="primary" @click="modifyMember()">确定</h-button>

          <h-button @click="moveVisible = false">取消</h-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, watch, ref } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { queryOrganPersonList } from "@/api/system";
import { queryUserList, batchUpdateUser } from "@/api/user";
import util from "@util/js";
import _ from "lodash";
export default defineComponent({
  name: "TabsTable",
  components: {},
  props: {
    role: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const state = reactive({
      tableParams: {
        hasSonDept: false,
        roleId: props.role.roleId,
      },
      transferKeys: [],
      treeOrganPerson: [],
      moveVisible: false,
      rootNodeKey: -1,
      columns: [
        {
          label: "用户名",
          prop: "username",
        },
        {
          label: "姓名",
          prop: "name",
        },
        {
          label: "部门",
          prop: "deptName",
        },
        {
          type: "operate",
          label: "操作",
          width: "100px",
          operates: [{ name: "移出", emitKey: "del", type: "danger" }],
        },
      ],
      dataSource: [],
    });
    const tableRef = ref(null);
    const refData = toRefs(state);
    watch(
      () => state.moveVisible,
      (v) => {
        if (v) {
          queryOrganPersonListAsycn();
        }
      }
    );
    //  获取部门列表（包含人员）
    const queryOrganPersonListAsycn = async () => {
      const result = await queryOrganPersonList();
      result.deptList.forEach((item) => {
        item.treeId = item.deptId;
        const children = item.userList || [];
        Reflect.deleteProperty(item, "userList");
        children.forEach((p) => {
          p.treeId = "person-" + p.userId;
        });
        item.children = children;
      });
      const options = { pid: "parentId", id: "deptId", rootPid: result.top };
      const treeData = util.arrayToTree(result.deptList, options);
      state.treeOrganPerson = treeData;
    };
    queryOrganPersonListAsycn();
    watch(
      () => props.role,
      (v) => {
        state.tableParams.roleId = v.roleId;
        refreshTable();
      }
    );

    // 移入移除成员按钮
    const moveMember = () => {
      state.moveVisible = true;
    };
    // 点击table操作按钮
    const handleClick = (operate, row) => {
      const { emitKey } = operate;
      if (emitKey === "del") {
        ElMessageBox.confirm("您确认要删除该用户吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {
            refreshTable();
            ElMessage({
              type: "success",
              message: "删除成功",
            });
          },
          () => {}
        );
      }
    };
    const refreshTable = () => {
      tableRef.value && tableRef.value.refresh();
    };

    // 修改成员
    const modifyMember = async () => {
      const forms = _.cloneDeep(state.transferKeys);
      forms.forEach((item) => {
        let ids = item.roleList.map((i) => i.roleId);
        if (ids.length === 0) {
          ids = [props.role.roleId];
        } else {
          if (!ids.includes(props.role.roleId)) {
            ids.push(props.role.roleId);
          }
        }
        item.roleIdList = ids;
      });
      const result = await batchUpdateUser(forms);
      if (result.code === 0) {
        ElMessage.success("添加成功");
        state.moveVisible = false;
        refreshTable();
      }
    };
    return {
      ...refData,
      queryUserList,
      moveMember,
      modifyMember,
      tableRef,
      handleClick,
    };
  },
});
</script>
<style lang="scss" scoped>
.TabsTable {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .organTransfer {
    height: 400px;
  }
}
</style>
